import React, { useEffect, useState } from "react";
import moment from "moment";
import { debounce } from "lodash";
import EditTransferRequestModal from "../EditTransferRequestModal";
import ViewTransferRequestModal from "../ViewTransferRequestModal";
import ViewPatientModal from "../ViewPatientModal";

import ViewPharmacyBranchModal from "../ViewPharmacyBranchModal";
import TransferInRequestService from "../../services/transfer-in-request.service";
import TransferOutRequestService from "../../services/transfer-out-request.service";
import PharmacyBranchService from "../../services/pharmacy-branch.service";
import PatientService from "../../services/patient.service";
import AcceptTransferRequestModal from "../AcceptTransferRequestModal";
import RejectTransferRequestModal from "../RejectTransferRequestModal";
import CancelTransferRequestModal from "../CancelTransferRequestModal";
import ManualAuctoComplateRequestModal from "../ManualAuctoComplateRequestModal";

import FinishReviewTransferRequestModal from "../FinishReviewTransferRequestModal";
import Emitter from "../../utility/emitter";
import helpers from "../../utility/helpers";
import "./index.scss";
import http from "../../utility/http";
import Swal from "sweetalert2";
import { Pagination } from "../Pagination";
import { useSelector } from "react-redux";
import { firstDoseState } from "../../atoms/firstDoes";
import { useRecoilState, useRecoilValue } from "recoil";
import { isPharmacyIntegratedSelector } from "../../atoms";
import Pusher from 'pusher-js';
import MessageAnotherPharmacyService from "../../services/MessageAnotherPharmacy.service";
import ResponseMesageAnotherPharmacy from "../ResponseMesageAnotherPharmacy";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";

let interval = null;
const TransferRequestDataGrid = (props) => {
  const [firstDose, setFirstDose] = useRecoilState(firstDoseState);
  console.log("firstDose", firstDose);
  const currentUser = useSelector((state) => state.currentUser);
  const isIntegrated = useRecoilValue(isPharmacyIntegratedSelector(currentUser?.user?.pharmacyId));
  const [futureFillFilter, setFutureFillFilter] = useState(false);
  const [futureFillLoading, setFutureFillLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(50);
  const [selectedStatusId, setSelectedStatusId] = useState(null);

  useEffect(() => {
    let pusher;
    let channel;
    console.log(currentUser);
    if (currentUser?.user?.pharmacyId) {
      pusher = new Pusher("bd3ebe27f306e286419c", {
        cluster: 'mt1'
      });

      channel = pusher.subscribe(`pharmacy-${currentUser.user.pharmacyBranchId}`);
      console.log(`pharmacy-${currentUser.user.pharmacyBranchId}`);
      channel.bind('update-transfer-request-list', function (data) {
        console.log('Received update:', data);
        getAll("", 1, limit, null, selectedStatusId, futureFillFilter);
      });
    }

    return () => {
      if (channel) {
        channel.unbind_all();
        channel.unsubscribe();
      }
      if (pusher) {
        pusher.disconnect();
      }
    };
  }, [currentUser?.user?.id, limit, selectedStatusId, futureFillFilter]);

  const deleteById = async (record) => {
    if (props.requesttype === 1) {
      await http.delete(
        `/v1/transfer/transfer-out-request/${record?.RequestId}`,
        {}
      );
    } else {
      await http.delete(
        `/v1/transfer/transfer-in-request/${record?.RequestId}`,
        {}
      );
    }
    await getAll(searchText, page, limit, null, selectedStatusId, futureFillFilter);
  };
  const [sortOrder, setSortOrder] = useState("desc");
  const debouncedSearch = debounce((keyword) => {
    setSearchText(keyword);
    getAll(keyword, page, limit, null, selectedStatusId, futureFillFilter);
  }, 300);

  //const records = useSelector((state) => (props.requesttype===1 ? state.transferOutRequests : state.transferInRequests))
  const [searchText, setSearchText] = useState("");
  const [editMode, setEditMode] = useState(false);
  const [acceptTransferRequestModalShow, setAcceptTransferRequestModalShow] =
    useState(false);
  const [
    finishReviewTransferRequestModalShow,
    setFinishReviewTransferRequestModalShow,
  ] = useState(false);
  const [rejectTransferRequestModalShow, setRejectTransferRequestModalShow] =
    useState(false);
  const [cancelTransferRequestModalShow, setCancelTransferRequestModalShow] =
    useState(false);
  const [
    manualAutoCompleteRequestModalShow,
    setManualAutoCompleteRequestModalShow,
  ] = useState(false);

  const [selectedRowIndex, setSelectedRowIndex] = useState({});
  const [request, setRequest] = useState({});
  const [pharmacyBranch, setPharmacyBranch] = useState({});
  const [patient, setPatient] = useState({});

  const [records, setRecords] = useState([]);
  const [transferRequestModalShow, setTransferRequestModalShow] =
    useState(false);
  const [viewTransferRequestModalShow, setViewTransferRequestModalShow] =
    useState(false);

  const [viewPharmacyBranchModalShow, setViewPharmacyBranchModalShow] =
    useState(false);
  const [viewPatientModalShow, setViewPatientModalShow] = useState(false);
  
  // Messaging states
  const [messageModalShow, setMessageModalShow] = useState(false);
  const [responseMessageModalShow, setResponseMessageModalShow] = useState(false);
  const [messageRecord, setMessageRecord] = useState(null);
  const [initialMessageText, setInitialMessageText] = useState("");
  const [selectedTransferRecord, setSelectedTransferRecord] = useState(null);

  const getStatusIcon = (statusId) => {
    switch (statusId) {
      case 1:
      case 2:
        return "warning";
      case 3:
        return "success";
      case 4:
      case 5:
        return "danger";
      default:
        return "";
    }
  };

  const [total, setTotal] = useState(0);
  const getAll = async (keyword, page, limit, sort = null, statusId = null, futureFillOnly = false) => {
    if (futureFillOnly) {
      setFutureFillLoading(true);
    }
    try {
      const result = await (props.requesttype === 1
        ? TransferOutRequestService
        : TransferInRequestService
      ).GetAll(keyword, page, limit, sort, statusId, futureFillOnly);
      if (result?.error === null) {
        setRecords(result?.data?.data);
        setTotal(result?.data?.total);
      }
    } finally {
      if (futureFillOnly) {
        setFutureFillLoading(false);
      }
    }
  };

  const modalListRefreshCb = (keyword, pageNum, limitNum) => {
    getAll(keyword, pageNum, limitNum, null, selectedStatusId, futureFillFilter);
  };

  // Export functionality
  const exportToCSV = () => {
    const headers = [
      "Request#",
      "Request Date",
      "Patient",
      "Rx Number",
      "Pharmacy",
      "Status"
    ];

    const csvData = records?.map(record => [
      record?.RequestId || '',
      moment(record?.RequestDate).format("YYYY-MM-DD") || '',
      record?.PatientName || '',
      record?.RxNumber || '',
      props.requesttype === 1
        ? `${record?.ToPharmacyBranchName} ${helpers.getPharmacyFormattedAddress(
          record?.ToPharmacyBranchAddress,
          record?.ToPharmacyBranchCityName,
          record?.ToPharmacyBranchStateName,
          true
        )}`
        : `${record?.FromPharmacyBranchName} ${helpers.getPharmacyFormattedAddress(
          record?.FromPharmacyBranchAddress,
          record?.FromPharmacyBranchCityName,
          record?.FromPharmacyBranchStateName,
          true
        )}`,
      record?.StatusName || ''
    ]);

    const csvContent = [headers, ...csvData]
      .map(row => row.map(field => `"${field}"`).join(','))
      .join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', `transfer_${props.requesttype === 1 ? 'out' : 'in'}_requests.csv`);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const exportToExcel = () => {
    const headers = [
      "Request#",
      "Request Date",
      "Patient",
      "Rx Number",
      "Pharmacy",
      "Status"
    ];

    const tableRows = records?.map(record => [
      record?.RequestId || '',
      moment(record?.RequestDate).format("YYYY-MM-DD") || '',
      record?.PatientName || '',
      record?.RxNumber || '',
      props.requesttype === 1
        ? `${record?.ToPharmacyBranchName} ${helpers.getPharmacyFormattedAddress(
          record?.ToPharmacyBranchAddress,
          record?.ToPharmacyBranchCityName,
          record?.ToPharmacyBranchStateName,
          true
        )}`
        : `${record?.FromPharmacyBranchName} ${helpers.getPharmacyFormattedAddress(
          record?.FromPharmacyBranchAddress,
          record?.FromPharmacyBranchCityName,
          record?.FromPharmacyBranchStateName,
          true
        )}`,
      record?.StatusName || ''
    ]);

    // Create tab-separated values (TSV) format - Excel handles this perfectly
    const excelContent = [headers, ...tableRows]
      .map(row => row.map(field => {
        // Clean field data and wrap in quotes if contains tabs or special characters
        const cleanField = String(field || '').replace(/\t/g, ' ').replace(/\n/g, ' ').replace(/\r/g, ' ');
        return cleanField.includes('\t') || cleanField.includes('"') ? `"${cleanField.replace(/"/g, '""')}"` : cleanField;
      }).join('\t'))
      .join('\n');

    const blob = new Blob(['\ufeff' + excelContent], { type: 'application/vnd.ms-excel;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', `transfer_${props.requesttype === 1 ? 'out' : 'in'}_requests.xls`);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const getDetailedById = async (id) => {
    const result = await (props.requesttype === 1
      ? TransferOutRequestService
      : TransferInRequestService
    ).GetById(id);
    if (result?.error === null) {
      setRequest(result?.data);

      /*setRecords(
        records?.map((record) => {
          if (record.RequestId === id) {
            record.IsRead = 1;
          }
          return record;
        })
      );*/

      Emitter.emit("update-notifications");
    }
  };

  const getDetailedPharmacyBranchById = async (id) => {
    const result = await PharmacyBranchService.GetById(id);
    if (result?.error === null) {
      setPharmacyBranch(result?.data[0][0]);
    }
  };

  const getDetailedPatientById = async (id) => {
    const result = await PatientService.GetById(id);
    if (result?.error === null) {
      setPatient(result?.data);
    }
  };

  const handleRefresh = (id) => {
    if (id !== undefined) {
      getDetailedById(id);
    }
  };

  const handleMessageClick = async (record) => {
    setSelectedTransferRecord(record);
    const requestType = `transferRequest_${record.RequestId}`;
    
    try {
      const result = await MessageAnotherPharmacyService.GetByRequestType(requestType);
      
      // Check if message exists
      // The http utility extracts response.data.data.data into result.data
      // But we also need to check result.responseData for the full response structure
      let messageData = null;
      
      if (result?.error === null) {
        // Check different possible response structures
        if (Array.isArray(result?.data)) {
          messageData = result.data;
        } else if (result?.data?.data && Array.isArray(result.data.data)) {
          messageData = result.data.data;
        } else if (result?.responseData?.data?.data && Array.isArray(result.responseData.data.data)) {
          messageData = result.responseData.data.data;
        }
        
        // If we have message data and it's not empty, show the response modal
        if (messageData && messageData.length > 0) {
          setMessageRecord(messageData[0]);
          setResponseMessageModalShow(true);
          return;
        }
      }
      
      // No message exists or error occurred, show initial message modal
      setMessageModalShow(true);
    } catch (error) {
      console.error("Error checking for messages:", error);
      // If error, show initial message modal
      setMessageModalShow(true);
    }
  };

  const handleCreateInitialMessage = async () => {
    if (!initialMessageText.trim()) {
      Swal.fire({
        icon: "warning",
        title: "Message Required",
        text: "Please enter a message to start the conversation.",
      });
      return;
    }

    const record = selectedTransferRecord;
    const formattedDateTime = moment().format();
    
    // Message FROM is always the current logged-in user's pharmacy
    const fromPharmacyId = currentUser.user.pharmacyBranchId;
    const fromPharmacyName = currentUser.user.pharmacyName;
    
    // Message TO is the other pharmacy (determined by transfer type)
    // For Transfer Out: current user is sending, so TO is the receiving pharmacy
    // For Transfer In: current user is receiving, so TO is the sending pharmacy
    const toPharmacyId = props.requesttype === 1 
      ? record.ToPharmacyBranchId 
      : record.FromPharmacyBranchId;
    const toPharmacyName = props.requesttype === 1 
      ? record.ToPharmacyBranchName 
      : record.FromPharmacyBranchName;

    const newMessage = {
      "fromPharmacy": fromPharmacyId,
      "fromPharmacyName": fromPharmacyName,
      "datetime": formattedDateTime,
      "pharmasticName": currentUser.user.firstname + " " + currentUser.user.lastname,
      "message": initialMessageText,
      "isRead": false
    };

    const newValues = {
      fromPharmacyId: fromPharmacyId,
      fromPharmacyName: fromPharmacyName,
      fromPharmacyNCPDP: currentUser.user.pharmacyId,
      toPharmacyId: toPharmacyId,
      toPharmacyNCPDP: props.requesttype === 1 
        ? record.ToPharmacyNCPDP 
        : record.FromPharmacyNCPDP,
      toPharmacyName: toPharmacyName,
      patientId: record.PatientId,
      patientName: record.PatientName,
      prescribedDrugId: null,
      prescribedDrugName: null,
      messageText: initialMessageText,
      requestType: `transferRequest_${record.RequestId}`,
      createdDate: formattedDateTime,
      isRead: 0,
      messages: JSON.stringify([newMessage]),
    };

    const result = await MessageAnotherPharmacyService.Create(newValues);
    if (result.error === null) {
      setInitialMessageText("");
      setMessageModalShow(false);
      // Show the response modal with the newly created message
      const getResult = await MessageAnotherPharmacyService.GetByRequestType(`transferRequest_${record.RequestId}`);
      const messageData = Array.isArray(getResult?.data) 
        ? getResult.data 
        : getResult?.data?.data || getResult?.responseData?.data?.data;
      if (getResult?.error === null && messageData && messageData.length > 0) {
        setMessageRecord(messageData[0]);
        setResponseMessageModalShow(true);
      }
    }
  };

  useEffect(() => {
    Emitter.on("update-transfer-request-list", () => {
      getAll(searchText, page, limit, null, selectedStatusId, futureFillFilter);
    });

    Emitter.emit("update-transfer-request-list");
    return () => {
      Emitter.off("update-transfer-request-list");
    };
  }, [page, limit, selectedStatusId, futureFillFilter]);
  // useEffect(() => {
  //   if (!interval) {
  //     interval = setInterval(() => {
  //       getAll("", 1, 50);
  //     }, 10000);
  //   }
  //   return () => {
  //     clearInterval(interval);
  //   };
  // }, []);
  console.log("currentUser?.user?.roleId", currentUser?.user?.roleId);
  return (
    <>
      <div className="card h-100 position-relative">
        {futureFillLoading && (
          <div
            className="transfer-grid-future-fill-loading d-flex flex-column align-items-center justify-content-center"
            role="status"
            aria-live="polite"
            aria-busy="true"
          >
            <Spinner animation="border" variant="info" />
            <span className="mt-2 text-muted small">Loading future fill…</span>
          </div>
        )}
        <div className="card-header d-flex justify-content-between align-items-center bg-white">
          <div className="d-flex align-items-center">
            {!isIntegrated && (currentUser?.user?.roleId === 1 ||
              currentUser?.user?.roleId === 2 ||
              currentUser?.user?.roleId === 3) && (
                <button
                  className="btn btn-default me-2"
                  type="button"
                  onClick={() => {
                    setRequest(null);
                    setEditMode(true);
                    setTransferRequestModalShow(true);
                  }}
                  test-id="send-or-request-transfer"
                >
                  {props.requesttype === 1 ? (
                    <>
                      <i className="fa-solid fa-arrow-up me-2"></i>
                      <span>Send A Transfer</span>
                    </>
                  ) : (
                    <>
                      <i className="fa-solid fa-arrow-down me-2"></i>
                      <span>Request A New Transfer In</span>
                    </>
                  )}
                </button>
              )}

            {/* Export buttons */}
            <div className="btn-group me-2">
              <button
                className="btn btn-outline-primary btn-sm"
                type="button"
                onClick={exportToCSV}
                disabled={!records || records.length === 0}
                title="Export to CSV"
              >
                <i className="fa-solid fa-file-csv me-1"></i>
                Export CSV
              </button>
              <button
                className="btn btn-outline-success btn-sm"
                type="button"
                onClick={exportToExcel}
                disabled={!records || records.length === 0}
                title="Export to Excel"
              >
                <i className="fa-solid fa-file-excel me-1"></i>
                Export Excel
              </button>

              <button
                className="btn btn-outline-success btn-sm"
                type="button"
                onClick={() => setLimit(10000)}
              >
                Get all for export
              </button>
            </div>
          </div>

          <div className="search-box">
            <i className="fa-solid fa-magnifying-glass"></i>
            <form onSubmit={(event) => event.preventDefault()}>
              <input
                type="text"
                className="form-control rounded-pill"
                placeholder="Search…"
                spellCheck="false"
                data-ms-editor="true"
                onChange={(event) => debouncedSearch(event.target.value)}
              />
            </form>
          </div>
        </div>

        {/* Status Filter Buttons - Above Table */}
        <div className="px-3 py-2 bg-light border-bottom">
          <div className="d-flex align-items-center">
            <span className="me-3 text-muted small fw-bold">Filter by Status:</span>
            <div className="btn-group" role="group">
              <button
                type="button"
                className={`btn btn-sm ${selectedStatusId === null && !futureFillFilter ? 'btn-primary' : 'btn-outline-primary'}`}
                onClick={() => {
                  setSelectedStatusId(null);
                  setFutureFillFilter(false);
                  setPage(1);
                }}
                title="Show all statuses"
              >
                All
              </button>
              <button
                type="button"
                className={`btn btn-sm ${selectedStatusId === 1 ? 'btn-warning text-white' : 'btn-outline-warning'}`}
                onClick={() => {
                  setFutureFillFilter(false);
                  setSelectedStatusId(1);
                  setPage(1);
                }}
                title="Pending Acceptance"
              >
                Pending Acceptance
              </button>
              <button
                type="button"
                className={`btn btn-sm ${selectedStatusId === 2 ? 'btn-warning text-white' : 'btn-outline-warning'}`}
                onClick={() => {
                  setFutureFillFilter(false);
                  setSelectedStatusId(2);
                  setPage(1);
                }}
                title="Pending Review"
              >
                Pending Review
              </button>
              <button
                type="button"
                className={`btn btn-sm ${selectedStatusId === 3 ? 'btn-success' : 'btn-outline-success'}`}
                onClick={() => {
                  setFutureFillFilter(false);
                  setSelectedStatusId(3);
                  setPage(1);
                }}
                title="Accepted"
              >
                Accepted
              </button>
              <button
                type="button"
                className={`btn btn-sm ${selectedStatusId === 4 ? 'btn-danger' : 'btn-outline-danger'}`}
                onClick={() => {
                  setFutureFillFilter(false);
                  setSelectedStatusId(4);
                  setPage(1);
                }}
                title="Rejected"
              >
                Rejected
              </button>
              <button
                type="button"
                className={`btn btn-sm ${selectedStatusId === 5 ? 'btn-danger' : 'btn-outline-danger'}`}
                onClick={() => {
                  setFutureFillFilter(false);
                  setSelectedStatusId(5);
                  setPage(1);
                }}
                title="Canceled"
              >
                Canceled
              </button>
              <button
                type="button"
                className={`btn btn-sm ${selectedStatusId === 6 ? 'btn-secondary' : 'btn-outline-secondary'}`}
                onClick={() => {
                  setFutureFillFilter(false);
                  setSelectedStatusId(6);
                  setPage(1);
                }}
                title="Draft"
              >
                Draft
              </button>
              <button
                type="button"
                className={`btn btn-sm ${futureFillFilter ? 'btn-info text-white' : 'btn-outline-info'}`}
                onClick={() => {
                  setFutureFillFilter(true);
                  setSelectedStatusId(null);
                  setPage(1);
                }}
                title="Date written more than 10 days in the future"
              >
                Future fill
              </button>
            </div>
          </div>
        </div>

        <div className="card-body datagrid p-0">
          <table className="table mb-0" test-id="data-table">
            <thead>
              <tr>
                <th
                  className="text-center"
                  onClick={() => {
                    setSortOrder(sortOrder === "asc" ? "desc" : "asc");
                    getAll(searchText, page, limit, {
                      sortOrder: sortOrder === "asc" ? "desc" : "asc",
                      sortBy: "request",
                    }, selectedStatusId, futureFillFilter);
                  }}
                >
                  Request# <i className="fa-solid fa-sort"></i>
                </th>
                <th
                  className="text-center"
                  onClick={() => {
                    setSortOrder(sortOrder === "asc" ? "desc" : "asc");
                    getAll(searchText, page, limit, {
                      sortOrder: sortOrder === "asc" ? "desc" : "asc",
                      sortBy: "date",
                    }, selectedStatusId, futureFillFilter);
                  }}
                >
                  Request Date <i className="fa-solid fa-sort"></i>
                </th>
                <th className="text-center">Patient</th>
                <th className="text-center">Rx Number</th>

                <th className="text-center">Pharmacy</th>
                <th
                  className="text-center"
                  onClick={() => {
                    setSortOrder(sortOrder === "asc" ? "desc" : "asc");
                    getAll(searchText, page, limit, {
                      sortOrder: sortOrder === "asc" ? "desc" : "asc",
                      sortBy: "status",
                    }, selectedStatusId, futureFillFilter);
                  }}
                >
                  Status <i className="fa-solid fa-sort"></i>
                </th>

                <th className="text-center">Actions</th>
              </tr>
            </thead>
            <tbody>
              {records?.map((record, index) => {
                const inFirstDose = firstDose?.inFirstDose(
                  record?.FromPharmacyId,
                  firstDose.pharmacies
                );
                return (
                  <tr
                    key={index}
                    className={[
                      index === selectedRowIndex
                        ? "selected"
                        : record?.IsRead === 0
                          ? "new"
                          : "",
                      // inFirstDose ? "inFirstDose" : "",
                    ].join(" ")}
                  >
                    <td className="text-center">
                      {record?.Notes && record.Notes.includes("[important!!]") && (
                        <span
                          className="ms-2"
                          title="Important RX to view"
                          style={{ cursor: "help" }}
                        >
                          <i className="fa fa-exclamation-triangle text-warning"></i>
                          {" "}
                        </span>
                      )}

                      {record?.RequestId}

                      {inFirstDose && (
                        <span className="badge bg-success ms-2">
                          First Dose
                        </span>
                      )}
                    </td>
                    <td className="text-center">
                      {moment(record?.RequestDate).format("MMMM DD YYYY")}
                    </td>
                    <td>
                      <a
                        className="btn btn-link"
                        onClick={async () => {
                          setSelectedRowIndex(index);
                          await getDetailedPatientById(record?.PatientId);
                          setViewPatientModalShow(true);
                        }}
                      >
                        {record?.PatientName}
                      </a>
                    </td>
                    <td className="text-center">{record?.RxNumber}</td>
                    <td>
                      <a
                        className="btn btn-link"
                        onClick={async () => {
                          setSelectedRowIndex(index);
                          await getDetailedPharmacyBranchById(
                            props.requesttype === 1
                              ? record?.ToPharmacyBranchId
                              : record?.FromPharmacyBranchId
                          );
                          setViewPharmacyBranchModalShow(true);
                        }}
                      >
                        {props.requesttype === 1
                          ? `${record?.ToPharmacyBranchName
                          } ${helpers.getPharmacyFormattedAddress(
                            record?.ToPharmacyBranchAddress,
                            record?.ToPharmacyBranchCityName,
                            record?.ToPharmacyBranchStateName,
                            true
                          )}`
                          : `${record?.FromPharmacyBranchName
                          } ${helpers.getPharmacyFormattedAddress(
                            record?.FromPharmacyBranchAddress,
                            record?.FromPharmacyBranchCityName,
                            record?.FromPharmacyBranchStateName,
                            true
                          )}`}
                      </a>
                    </td>
                    <td>
                      <div className="d-flex align-items-center justify-content-center">
                        <i
                          className={`fa-solid fa-circle text-${getStatusIcon(
                            record?.StatusId
                          )} me-1`}
                        ></i>
                        <div>{record?.StatusName}</div>
                        <div></div>
                      </div>
                    </td>
                    <td>
                      <div className="d-flex justify-content-center">
                        <a
                          href="#"
                          className={`view${!record?.actions?.view ? " disabled" : ""
                            }`}
                          title="View"
                          data-toggle="tooltip"
                          onClick={async () => {
                            record.IsRead = 1;
                            setSelectedRowIndex(index);
                            await getDetailedById(record?.RequestId);
                            setEditMode(false);
                            setViewTransferRequestModalShow(true);
                          }}
                        >
                          <i className="fa-solid fa-eye"></i>
                        </a>
                        <a
                          href="#"
                          className="message"
                          title="Message"
                          data-toggle="tooltip"
                          onClick={async () => {
                            setSelectedRowIndex(index);
                            await handleMessageClick(record);
                          }}
                        >
                          <i 
                            className={`fa-solid fa-message ${record?.ishaveMessages === 1 ? 'text-success' : ''}`}
                            style={record?.ishaveMessages === 1 ? { color: '#198754' } : {}}
                          ></i>
                        </a>
                        {!isIntegrated && (currentUser?.user?.roleId === 1 ||
                          currentUser?.user?.roleId === 2 ||
                          currentUser?.user?.roleId === 3) && (
                            <>
                              <a
                                href="#"
                                className={`edit${!record?.actions?.edit ? " disabled" : ""
                                  }`}
                                title="Edit"
                                data-toggle="tooltip"
                                onClick={async () => {
                                  record.IsRead = 1;
                                  setSelectedRowIndex(index);
                                  await getDetailedById(record?.RequestId);
                                  setEditMode(true);
                                  setTransferRequestModalShow(true);
                                }}
                              >
                                <i className="fa-solid fa-pen-to-square"></i>
                              </a>
                              <a
                                href="#"
                                title="Delete"
                                data-toggle="tooltip"
                                onClick={async () => {
                                  // await deleteById(record);
                                  const result = await Swal.fire({
                                    title: "",
                                    text: `Are you sure you want to delete this? ?`,
                                    icon: "warning",
                                    showCancelButton: true,
                                    confirmButtonColor: "#3085d6",
                                    cancelButtonColor: "#6c757d",
                                    confirmButtonText: "Yes",
                                  });
                                  if (result.isConfirmed) {
                                    await deleteById(record);
                                  }
                                }}
                              >
                                <i className="fa-solid fa-trash"></i>
                              </a>
                            </>
                          )}
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <Pagination setPage={setPage} page={page} total={total} limit={limit} />
        {/* <div className="card-footer d-flex justify-content-between align-items-center bg-white">
          <div className="hint-text">
            Showing <b>{(page - 1) * limit + 1}</b> to{" "}
            <b>{Math.min(page * limit, total)}</b> of <b>{total}</b> entries
          </div>
          <nav aria-label="Page navigation">
            <ul className="pagination mb-0">
              <li className="page-item ">
                <a
                  className="page-link"
                  href="#"
                  aria-label="Previous"
                  onClick={(e) => {
                    e.preventDefault();
                    if (page > 1) {
                      setPage(page - 1);
                    }
                  }}
                >
                  <span aria-hidden="true">&laquo;</span>
                </a>
              </li>
              {Array(Math.ceil(total / limit))
                .fill()
                .map((_, i) => (
                  <li className={`page-item ${i + 1 === page ? "active" : ""}`}>
                    <a
                      className="page-link"
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        setPage(i + 1);
                      }}
                    >
                      {i + 1}
                    </a>
                  </li>
                ))}
              <li className="page-item">
                <a
                  className="page-link"
                  href="#"
                  aria-label="Next"
                  onClick={(e) => {
                    e.preventDefault();
                    if (page < Math.ceil(total / limit)) {
                      setPage(page + 1);
                    }
                  }}
                >
                  <span aria-hidden="true">&raquo;</span>
                </a>
              </li>
            </ul>
          </nav>
        </div> */}
      </div>

      <EditTransferRequestModal
        cb={modalListRefreshCb}
        show={transferRequestModalShow}
        onHide={(refresh, transferRequestId) => {
          setTransferRequestModalShow(false);
          getAll(searchText, page, limit, null, selectedStatusId, futureFillFilter);
          if (refresh === true) {
            handleRefresh(transferRequestId);
          }
        }}
        requesttype={props.requesttype}
        request={request}
        handleAcceptTransferRequestModalShow={(state) =>
          setAcceptTransferRequestModalShow(state)
        }
        handleFinishReviewTransferRequestModalShow={(state) =>
          setFinishReviewTransferRequestModalShow(state)
        }
        handleRejectTransferRequestModalShow={(state) =>
          setRejectTransferRequestModalShow(state)
        }
        handleCancelTransferRequestModalShow={(state) =>
          setCancelTransferRequestModalShow(state)
        }
      />

      <ViewTransferRequestModal
        show={viewTransferRequestModalShow}
        onHide={() => {
          getAll(searchText, page, limit, null, selectedStatusId, futureFillFilter);
          setViewTransferRequestModalShow(false);
        }}
        requesttype={props.requesttype}
        request={request}
        handleEditTransferRequestModalShow={(state) =>
          setTransferRequestModalShow(state)
        }
        handleAcceptTransferRequestModalShow={(state) =>
          setAcceptTransferRequestModalShow(state)
        }
        handleFinishReviewTransferRequestModalShow={(state) =>
          setFinishReviewTransferRequestModalShow(state)
        }
        handleRejectTransferRequestModalShow={(state) =>
          setRejectTransferRequestModalShow(state)
        }
        handleCancelTransferRequestModalShow={(state) =>
          setCancelTransferRequestModalShow(state)
        }
        handleManualAutoCompleteRequestModalShow={(state) =>
          setManualAutoCompleteRequestModalShow(state)
        }
      />

      <AcceptTransferRequestModal
        show={acceptTransferRequestModalShow}
        onHide={(refresh) => {
          setAcceptTransferRequestModalShow(false);
          getAll(searchText, page, limit, null, selectedStatusId, futureFillFilter);
          if (refresh === true) {
            if (editMode) {
              setTransferRequestModalShow(false);
            }
            handleRefresh(editMode ? undefined : request.RequestId);
          }
        }}
        requesttype={props.requesttype}
        request={request}
      />

      <FinishReviewTransferRequestModal
        show={finishReviewTransferRequestModalShow}
        onHide={(refresh) => {
          setFinishReviewTransferRequestModalShow(false);
          getAll(searchText, page, limit, null, selectedStatusId, futureFillFilter);
          if (refresh === true) {
            if (editMode) {
              setTransferRequestModalShow(false);
            }
            handleRefresh(editMode ? undefined : request.RequestId);
          }
        }}
        requesttype={props.requesttype}
        request={request}
      />

      <RejectTransferRequestModal
        show={rejectTransferRequestModalShow}
        onHide={(refresh) => {
          setRejectTransferRequestModalShow(false);
          getAll(searchText, page, limit, null, selectedStatusId, futureFillFilter);
          if (refresh === true) {
            if (editMode) {
              setTransferRequestModalShow(false);
            }
            handleRefresh(editMode ? undefined : request.RequestId);
          }
        }}
        requesttype={props.requesttype}
        request={request}
      />
      <CancelTransferRequestModal
        show={cancelTransferRequestModalShow}
        onHide={(refresh) => {
          setCancelTransferRequestModalShow(false);
          getAll(searchText, page, limit, null, selectedStatusId, futureFillFilter);
          if (refresh === true) {
            if (editMode) {
              setTransferRequestModalShow(false);
            }
            handleRefresh(editMode ? undefined : request.RequestId);
          }
        }}
        request={request}
      />

      <ManualAuctoComplateRequestModal
        show={manualAutoCompleteRequestModalShow}
        onHide={(refresh) => {
          setManualAutoCompleteRequestModalShow(false);
          getAll(searchText, page, limit, null, selectedStatusId, futureFillFilter);
          if (refresh === true) {
            if (editMode) {
              setTransferRequestModalShow(false);
            }
            handleRefresh(editMode ? undefined : request.RequestId);
          }
        }}
        request={request}
      />

      <ViewPharmacyBranchModal
        show={viewPharmacyBranchModalShow}
        onHide={() => setViewPharmacyBranchModalShow(false)}
        data={pharmacyBranch}
      />

      <ViewPatientModal
        show={viewPatientModalShow}
        onHide={() => setViewPatientModalShow(false)}
        data={patient}
      />

      {/* Initial Message Modal */}
      <Modal
        show={messageModalShow}
        onHide={() => {
          setMessageModalShow(false);
          setInitialMessageText("");
        }}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Start Messaging</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>There is no initial message for this transfer. Please enter a message to start the conversation.</p>
          <Form.Group className="mb-3">
            <Form.Label>Message</Form.Label>
            <Form.Control
              as="textarea"
              rows={4}
              value={initialMessageText}
              onChange={(e) => setInitialMessageText(e.target.value)}
              placeholder="Enter your message here..."
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setMessageModalShow(false);
              setInitialMessageText("");
            }}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleCreateInitialMessage}
          >
            Send Message
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Response Message Modal */}
      {messageRecord && (
        <ResponseMesageAnotherPharmacy
          isOpen={responseMessageModalShow}
          onClose={() => {
            setResponseMessageModalShow(false);
            setMessageRecord(null);
            getAll(searchText, page, limit, null, selectedStatusId, futureFillFilter);
          }}
          record={messageRecord}
        />
      )}
    </>
  );
};

export default TransferRequestDataGrid;
